import { Icon, IconName } from '../icons';
import { StyledErrorMessage } from './styled';

export function ErrorMessage({ text }: { text: string }): JSX.Element {
  return (
    <StyledErrorMessage>
      <Icon name={IconName.Warning} />
      {text}
    </StyledErrorMessage>
  );
}
